import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgShare = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 6a3 3 0 01-5.276 1.954l-4.112 2.57a2.986 2.986 0 01.287 2.25l4.04 3.045a3 3 0 11-.8 1.275L9.152 14.09a3 3 0 11-.613-4.665L13.06 6.6A3 3 0 1119 6zM8 12a1 1 0 11-2 0 1 1 0 012 0zm8 7a1 1 0 100-2 1 1 0 000 2zm1-13a1 1 0 11-2 0 1 1 0 012 0z"
      clipRule="evenodd"
    />
  </svg>
));
SvgShare.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgShare;
